import comp from "./SubjectDependenciesInfo";
export default comp;
